<template>
  <v-row class="homepage fill-height mx-0" align="center" justify="center">
    <transition mode="out-in">
      <div class="p-absolute w-100 h-100 background-holder o-hidden">
        <div class="p-absolute w-100 h-100 paper-background" ref="background" :data-disabled="pageDisabled">
          <Scribbles />
          <!-- Postcards -->
          <div class="p-absolute w-100 postcards-holder" v-if="Exhibitions" ref="postcardHolder">
            <div class="p-absolute w-100 h-100 mobile-helper">
              <div class="postcards-content p-absolute w-100 h-100" :data-over="exploreOver" :data-active="!intro" :data-selected="interactive && selectedExhib !== null" >
                <div v-for="(item, key) in Exhibitions.items" :key="key" class="p-absolute w-100 h-100 postcard-item">
                  <v-img eager :src="optimizedImageURL(!item.isVideoExhibition ? item.roomImage : item.videoBackground, {breakpointSize: $vuetify.breakpoint, quality: 90})" :lazy-src="getLazySrc(!item.isVideoExhibition ? item.roomImage : item.videoBackground)" cover width="100%" height="100%" position="0% 50%" />
                  <v-img eager :src="transitionImage[key]" class="p-absolute w-100 h-100 postcard-item__pic" cover width="100%" height="100%" position="0% 50%" />
                </div>
                <div class="p-absolute w-100 h-100 default-postcard">
                  <v-img eager :src="manorBackgrund" cover width="100%" height="100%" position="50% 50%" />
                </div>
              </div>
              <!-- Exhibitions -->
              <div class="p-absolute w-100 h-100 exhibitions-holder" ref="exhibitionsHolder" v-if="Exhibitions">
                <div class="p-absolute w-100 h-100 exhibitions-content" :data-hide="pageDisabled">
                  <div v-for="(exhib, key) in Exhibitions.items" :key="key" class="p-absolute exhibition-item" :data-cursor-target="`arrow||.5|${exhibitionList[key].iconRotation}`" :data-selected="selectedExhib === key" @click="gotoExhib(exhib)">
                    <div class="p-absolute w-100 h-100 exhibition-item__pic" :data-hide="interactive && selectedExhib !== null && selectedExhib !== key" @mouseenter="selectedExhib = key" @mouseleave="!pageDisabled ? selectedExhib = null : selectedExhib = selectedExhib">
                      <v-img eager :src="exhibitionList[key].src" cover width="100%" height="100%" position="50% 50%" />
                      <p class="text-script">{{ exhib.title }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <DeletedText1 class="deleted-text deleted-text--1" />
              <DeletedText3 class="deleted-text deleted-text--3" />
            </div>
          </div>
          <!-- Intro -->
          <v-col cols="10" key="intro" class="text-center">
              <hgroup class="text-left" ref="h1">
              <h1 ref="h1" class="text-sans">
                <div data-type="mobile" ref="introMobile">
                  <span v-html="getLabel('The first conscious fashion photography festival that focuses on the common ground between ethics and aesthetics.')" />
                </div>
                <div data-type="desktop" ref="introDesktop">
                  <span class="line px-3 pb-1" v-html="getLabel('The first conscious fashion')" />
                  <span class="line px-3 pb-1" v-html="getLabel('photography festival that focuses')" />
                  <span class="line px-3 pb-1" v-html="getLabel('on the common ground between')" />
                  <span class="line px-3 pb-1" v-html="getLabel('ethics and aesthetics.')" />
                </div>
              </h1>
              <div class="explore ml-md-8 mt-4 mt-md-8" ref="explore">
                <div class="d-flex" @mouseenter="exploreOver = true" @mouseleave="exploreOver = false" @click="transitionOut">
                  <div class="icon animated-eye" />
                  <p class="text-script red--text mb-0 ml-3">Explore</p>
                </div>
              </div>
            </hgroup>
          </v-col>
        </div>
        <div class="p-relative button-holder" ref="buttonHolder" :data-exhibition="!intro" >
          <v-btn class="bottom-left-btn text-script" :small="!$vuetify.breakpoint.xs" :x-small="$vuetify.breakpoint.xs" text :to="{name: RouteNames.ABOUT.name}" data-cursor-target="asterisk|center center">Thanks to</v-btn>
          <v-btn :small="$vuetify.breakpoint.smAndDown" text class="mode-switch-btn text-script" :to="{name: RouteNames.PROGRAM.name}" data-cursor-target="calendar|center center">The Talks</v-btn>
          <v-btn v-if="$vuetify.breakpoint.mdAndUp" text class="mode-tailored-btn text-script" :to="{name: RouteNames.SPECIAL_PROJECTS.name}"><component :is="arrowIcon" class="mr-4" />Tailored Creativity</v-btn>
          <v-btn x-small v-if="$vuetify.breakpoint.smAndDown" text class="bottom-right-btn text-script" :to="{name: RouteNames.SPECIAL_PROJECTS.name}">Tailored Creativity</v-btn>
        </div>
      </div>
    </transition>
  </v-row>
</template>

<script>
// eslint-disable-next-line
import gsap from 'gsap'
import { Viewport } from '@monogrid/vue-lib'
import Scribbles from '@/molecules/Scribbles'
import ListExhibition from '@/graphql/ListExhibition.gql'
import manorBackgrund from '@/assets/img/intro/manor.jpg'
import exhib01 from '@/assets/img/intro/exhib-01.png'
import exhib02 from '@/assets/img/intro/exhib-02.png'
import exhib04 from '@/assets/img/intro/exhib-04.png'
import allInTransitionImage from '@/assets/img/intro/all-in-together-transition.png'
import inThePictureTransitionImage from '@/assets/img/intro/in-the-picture-transition.png'
import projectionsTransitionImage from '@/assets/img/intro/projections-transition.png'
import arrowIcon from '@/assets/img/next-icon.svg'
import DeletedText1 from '@/assets/img/deleted-text-1.svg'
import DeletedText3 from '@/assets/img/deleted-text-3.svg'
import { optimizedImageURL, getLazySrc } from '@/services/OptimizedImage'

export default {
  name: 'Home',

  mixins: [Viewport],

  components: {
    Scribbles,
    DeletedText1,
    DeletedText3
  },

  data () {
    return {
      intro: true,
      exploreOver: false,
      interactive: false,
      selectedExhib: null,
      pageDisabled: false,
      manorBackgrund,
      arrowIcon,
      transitionImage: [
        allInTransitionImage,
        inThePictureTransitionImage,
        projectionsTransitionImage
      ],
      exhibitionList: [
        {
          x: '-50%',
          y: '-50%',
          rotation: 0,
          src: exhib01,
          iconRotation: 235
        },
        {
          x: '65%',
          y: '-40%',
          rotation: 0,
          src: exhib02,
          iconRotation: 0
        },
        {
          x: '-50%',
          y: '35%',
          rotation: 15,
          src: exhib04,
          iconRotation: 180
        }
      ],
      transitions: [
        {
          duration: 6,
          scale: 2,
          x: '0%',
          y: '0%',
          autoAlpha: 0,
          ease: 'expo.inOut'
        },
        {
          duration: 5,
          scale: 9,
          x: '0%',
          y: '-100%',
          autoAlpha: 0,
          ease: 'expo.inOut'
        },
        {
          duration: 5,
          scale: 1.7,
          delay: 0.5,
          x: '0%',
          y: '55%',
          // autoAlpha: 0,
          ease: 'quint.inOut'
        }
      ]

    }
  },

  apollo: {
    Exhibitions: {
      query: ListExhibition,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'priority',
          descending: true
        }
      },
      result () {
        this.$nextTick(() => { this.transitionIn() })
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },

  methods: {
    optimizedImageURL,
    getLazySrc,
    getRandomArbitrary (min, max) {
      return Math.random() * (max - min) + min
    },
    gotoExhib (exhib) {
      this.pageDisabled = true
      const selectedPostcard = this.$el.querySelectorAll('.postcard-item')[this.selectedExhib]

      const { postcardHolder, buttonHolder } = this.$refs
      const timeline = gsap.timeline()

      timeline.to(postcardHolder, {
        duration: 4,
        scale: this.$vuetify.breakpoint.smAndDown ? 1.5 : 1,
        ease: 'quint.inOut'
      })

      timeline.to(buttonHolder, {
        duration: 1,
        autoAlpha: 0,
        ease: 'expo.out'
      }, '<')

      timeline.to(selectedPostcard, {
        duration: 4,
        scale: 1,
        ease: 'quint.inOut'
      }, '<')

      timeline.to(selectedPostcard.querySelector('.postcard-item__pic'), this.transitions[this.selectedExhib], '<')

      setTimeout(() => {
        this.$router.push({ name: exhib.isVideoExhibition ? 'VideoExhibition' : 'PhotoExhibition', params: { slug: exhib._slug, preloadedImage: this.Exhibitions.items[this.selectedExhib].roomImage } })
      }, 4000)
    },
    getLabel (label) {
      const parsedLabel = []

      label.split(' ').forEach(word => {
        const letters = []

        word.split('').forEach(letter => {
          letters.push(`<span class="letter d-inline-block">${letter === ' ' ? '&nbsp;' : letter}</span>`)
        })

        parsedLabel.push(`<span class="word d-inline-block">${letters.join('')}</span>`)
      })

      return parsedLabel.join('&nbsp;')
    },
    transitionIn () {
      const { background, introDesktop, introMobile, explore } = this.$refs
      const lines = introDesktop.querySelectorAll('span.line')
      // const letters = introDesktop.querySelectorAll('span.letter')
      const words = introDesktop.querySelectorAll('span.word')
      const wordsMobile = introMobile.querySelectorAll('span.word')
      const timeline = gsap.timeline()

      gsap.set([words, wordsMobile], { opacity: 0, y: 50 })
      timeline.to(background, {
        duration: 2,
        opacity: 1,
        scale: 1,
        ease: 'expo.out'
      }, '<')

      timeline.to(lines, {
        duration: 4,
        opacity: 1,
        rotation: 0,
        stagger: 0.1,
        ease: 'quint.out'
      }, '<')

      /*
      timeline.to(letters, {
        duration: 3,
        opacity: 1,
        y: 0,
        stagger: 0.015,
        ease: 'expo.out'
      }, '-=3')
      */

      timeline.to(words, {
        duration: 2.1,
        opacity: 1,
        y: 0,
        stagger: 0.05,
        ease: 'quint.inOut'
      }, '<')

      timeline.to(wordsMobile, {
        duration: 2.1,
        opacity: 1,
        y: 0,
        stagger: 0.05,
        ease: 'quint.inOut'
      }, '<')

      timeline.to(explore, {
        duration: 3,
        opacity: 1,
        y: 0,
        ease: 'expo.out'
      }, '-=3')
    },

    transitionOut () {
      this.intro = false

      const { h1, postcardHolder, exhibitionsHolder, buttonHolder } = this.$refs
      const postcardItems = postcardHolder.querySelectorAll('.postcard-item')
      const exhibitionItems = exhibitionsHolder.querySelectorAll('.exhibition-item')
      const timeline = gsap.timeline()

      timeline.to(h1, {
        duration: 2,
        autoAlpha: 0,
        ease: 'expo.out'
      })

      timeline.to(postcardHolder, {
        duration: 4,
        scale: 0.35,
        rotation: -8,
        ease: 'expo.inOut'
      }, '<')

      postcardItems.forEach((postcard, i) => {
        const x = this.getRandomArbitrary(-65, 35)
        const y = this.getRandomArbitrary(-65, 35)
        const rotation = this.getRandomArbitrary(5, 10)

        postcard.__default = { x, y, rotation }

        timeline.to(postcard, {
          duration: 4,
          x,
          y,
          rotation,
          ease: 'expo.inOut'
        }, '<')
      })

      exhibitionItems.forEach((exhib, i) => {
        const { x, y, rotation } = this.exhibitionList[i]
        gsap.to(exhib, {
          delay: 1.5,
          duration: 5,
          x,
          y,
          rotation,
          ease: 'expo.out'
        })
      })

      timeline.to(buttonHolder, {
        duration: 2,
        autoAlpha: 1,
        ease: 'expo.out'
      }, '-=2')

      setTimeout(() => {
        this.interactive = true
      }, 2000)
    }
  },

  watch: {
    selectedExhib (index, oldIndex) {
      if (!this.interactive) return

      const { postcardHolder } = this.$refs
      const postcardItems = postcardHolder.querySelectorAll('.postcard-item')

      if (index !== null) {
        const activePostcard = postcardItems[index]
        activePostcard.style.zIndex = 4
        gsap.killTweensOf(activePostcard)
        gsap.to(activePostcard, {
          duration: 1.65,
          x: 0,
          y: 0,
          rotation: 8,
          scale: 1.2,
          ease: 'expo.out'
        })
      }

      if (oldIndex !== null) {
        const oldPostcard = postcardItems[oldIndex]
        const { x, y, rotation } = oldPostcard.__default
        oldPostcard.style.zIndex = 1
        gsap.killTweensOf(oldPostcard)
        gsap.to(oldPostcard, {
          duration: 1.35,
          x,
          y,
          rotation,
          scale: 1,
          ease: 'expo.out'
        })
      }
    }
  },

  computed: {
    complexTranslation: function () {
      // this is an example of a complex translation that implements strong tags / router links / lists etc

      // comment for translator: in homepage
      return this.$gettext('Please feel free to\n\n- ~~stress [Daniele](mailto:daniele@mono-grid.com)~~\n- [Switch Language](Home "language: \'it\'") to Italian')
    }
  },

  metaInfo: function () {
    return {
      // home page browser title
      title: this.$gettext('Home Page')
    }
  }
}
</script>

<style scoped lang="scss">

  .homepage {
    position: relative;
    width: 100vw;
  }

  .mobile-helper {
    transform: scale(0.9);

    @include breakpoint(sm-and-up) {
      transform: scale(1);
    }
  }

  .postcards-holder {
    padding-bottom: 100vh;
    width: 177.78vh;
    height: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1.5);
    // pointer-events: none;

    @media (min-aspect-ratio: 16/9) {
      width: 100vw;
      padding-bottom: 56.25vw;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .postcards-content {
    opacity: 0;
    transition: opacity 2s 0s $ease-out-expo;
    pointer-events: none;
    transform: scale(0.75);

    @include breakpoint(md-and-up) {
      transform: scale(1);
    }

    &[data-over] {
      opacity: 0.25;
    }

    &[data-active] {
      opacity: 1 !important;
    }

    &[data-selected] {
      z-index: 4;
      opacity: 1 !important;
    }
  }

  .postcard-item,
  .exhibition-item,
  .postcards-content,
  .postcards-holder,
  .button-holder {
    // z-index: 9;
    will-change: transform;
    backface-visibility: hidden;
  }

  .postcard-item__pic {
    top: 0;
    left: 0;
  }

  .default-postcard {
    z-index: 2;
  }

  .exhibitions-holder {
    z-index: 99;
    width: 40%;
    left: 50%;
    transform: translateX(-50%);

    @include breakpoint(md-and-up) {
      width: 100%;
    }
  }

  .exhibitions-content {
    transition: opacity 2s 0s $ease-out-expo;

    &[data-hide] {
      opacity: 0;
    }
  }

  .exhibition-item {
    position: relative;
    width: 700px;
    height: 700px;

    @include breakpoint(md-and-up) {
      width: 900px;
      height: 900px;
    }

    &[data-selected] {
      opacity: 1 !important;
    }

    p {
      position: absolute;
      font-size: 2rem;
      width: 50%;
      transform: rotate(8deg);

      @include breakpoint(md-and-up) {
        font-size: 3rem;
        width: 50%;
      }
    }

    &:nth-child(1) {
      top: 0;
      left: 0;
      transform: translate3d(-100%, -100%, 0) rotate(-30deg);

      p {
        top: 0%;
        left: 50%;
        transform: translate(-50%, -20px);

        @include breakpoint(md-and-up) {
          top: inherit;
          bottom: 65%;
          left: -10%;
          transform: translate(0, 0);
        }
      }
    }

    &:nth-child(2) {
      top: 0;
      right: 0;
      transform: translate3d(100%, -100%, 0) rotate(30deg);

      p {
        top: 10%;
        left: 50%;
        transform: translate(-60%, -75px);

        @include breakpoint(md-and-up) {
          top: inherit;
          left: inherit;
          bottom: 0%;
          right: -15%;
          transform: translate(0, 0);
          white-space: nowrap;
        }
      }
    }

    &:nth-child(3) {
      bottom: 0;
      left: 5%;
      transform: translate3d(0%, 100%, 0) rotate(25deg);

      p {
        bottom: 15%;
        left: 100%;
        transform: translate(0%, -100px);

        @include breakpoint(md-and-up) {
          bottom: 0%;
          left: 0%;
          left: inherit;
          transform: translate(0, 0);
        }
      }
    }
  }

  .exhibition-item__pic {
    transition: opacity 1s 0s $ease-out-expo;
    opacity: 1;

    &[data-hide] {
      opacity: 0.25;
    }
  }

  hgroup {
    position: relative;

    h1 {
      user-select: none;
      font-size: 2.25rem;
      line-height: 1;

      @include breakpoint(md-and-up) {
        font-size: 3rem;

        > div[data-type='mobile'] {
          display: none !important;
        }

        > div[data-type='desktop'] {
          display: block !important;
        }
      }

      @include breakpoint(lg-and-up) {
        font-size: 4.25rem;
      }

      > div[data-type='mobile'] {
        display: block;
        line-height: 1.15;
      }

      > div[data-type='desktop'] {
        display: none;
      }

      span {
        &.line {
          display: block;
          transform-origin: center left;
          transform: rotate(30deg);
          opacity: 0;
          overflow: hidden;
        }
      }
    }
  }

  @keyframes eyeStop {
    from {background-position-x: 0;}
    to {background-position-x: -#{60px * 5}; }
  }

  .explore {

    position: relative;
    display: flex;
    transform: translateY(50%);
    opacity: 0;
    cursor: pointer;

    > div {
      align-items: center;
      transition: all 1s $ease-out-expo;
    }

    &:hover {
      > div {
        transform: scale(1.2) rotate(-5deg);
      }

      .icon {
        animation: eyeStop 1s steps(5) infinite alternate-reverse;
      }
    }

    .icon {
      position: relative;
      flex: 0 0 60px;
    }

    p {
      font-size: 0.75rem;
    }

  }

  .paper-background {
    top: 0;
    left: 0;
    opacity: 0;
    transform: scale(1.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    &[data-disabled] {
      pointer-events: none !important;
    }
  }

  .button-holder {
    display: none;
    opacity: 0;
    pointer-events: none;

    .v-btn {
      pointer-events: all;
    }

    &[data-exhibition] {
      display: block;
      pointer-events: all;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      pointer-events: none;
    }
  }

  .mode-switch-btn {
    position: fixed;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
  }

  .mode-tailored-btn {
    position: fixed;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%) scale(0.65);

    @include breakpoint(sm-and-up) {
      transform: translate(-50%) scale(1);
    }

    svg {
      position: relative;
      transform: rotate(90deg);
      width: 80px;

      path {
        // stroke: #e00;
        fill: #e00;
      }
    }
  }

  .deleted-text {
    display: none;

    @include breakpoint(md-and-up) {
      display: block;

      &--1 {
        position: absolute;
        top: 0;
        transform: translate(-50%, -170px) scale(2);
        left: 50%;
      }

      &--3 {
        position: absolute;
        bottom: -25%;
        transform: translate(-65%, 0) rotate(8deg) scale(3);
        right: 0%;
      }
    }
  }

</style>
